import React, { useLayoutEffect }  from 'react';
import ReactDOM from 'react-dom/client';
import './stylesheets/simple-grid.css';
import './stylesheets/index.css';
import './stylesheets/animations.css';
import './stylesheets/header.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { HashRouter as Router, useLocation } from "react-router-dom";

const ScrollWrapper = ({ children }) => {
  const location = useLocation();
  useLayoutEffect(() => {
    document.documentElement.scrollTo(0, 0);
  }, [location.pathname]);
  return children
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <ScrollWrapper>
        <App />
      </ScrollWrapper>
    </Router>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
